<template>
  <b-tooltip :label="textLabel"
    :active="activeTooltip"
    :position="positionTooltip">
    <button type="button"
      class="h-9 w-9 rounded-full"
      :class="[withBg ? bgClass || 'bg-gray-200' : `hover:bg-gray-200`, textClass || 'text-black']"
      :disabled="disabled"
      @click="handleClick">
      <b-icon v-if="icon" :icon="icon" pack="fas"></b-icon>
      <span class="mx-1 hidden xl:inline-">{{ $t(textLabel) }}</span>
      <span v-if="textSup != null"
        class="absolute right-0 top-0 -mt-2 -mr-1 text-xs bg-red-500 text-white font-medium px-2 shadow-lg rounded-full"
        style="background-color:  rgba(59, 130, 246, 0.5);">{{ textSup }}</span>
    </button>
  </b-tooltip>
</template>

<script>

  export default {
    name: 'button-circle',

    computed: {

    },

    components: {},

    props: {
      textLabel: { type: String, required: true },
      textSup: { type: String, default: null },
      icon: { type: String, default: null },
      activeTooltip: { type: Boolean, default: false },
      positionTooltip: { type: String, default: 'is-top' },
      withBg: { type: Boolean, default: true },
      disabled: { type: Boolean, default: false },
      handleOnClick: { type: Function, required: true },
      bgClass: { type: String },
      textClass: { type: String }
    },

    data: () => ({

    }),

    watch: {},

    mounted() {
    },

    methods: {
      handleClick() {
        this.handleOnClick()
      }
    },

  };
</script>
